<!-- prettier-ignore -->

<ion-app (click)="increaseClick()">
  <!-- <app-sentry-example></app-sentry-example> -->

  @if(!hideHeaderOnCurrentRoute() && tools.showHeader() && (tools.isApp || tools.isDistributor || isRegisterMode()) && !tools.isPlannerMode()){
    <app-header />
  }

  <div [@routeAnimations]="prepareRoute(outlet)" class="route-container">
    <router-outlet [ngClass]="{'animation-open': tools.showMenuDropdown === true, 'animation-close': tools.showMenuDropdown === false}" #outlet="outlet" />
  </div>

  @if(chatId() &&
     isOnline() &&
     (tools.isApp || tools.isDistributor) && (!hideHeaderOnCurrentRoute() && (!isCustomRoute() || !isMobile()))
  ){
    <chat-bot-standalone [chatID]="chatId()" />
  }

  @if(!tools.isPlannerMode()){
    @if(isAppLoaded() && !isTechMode() && !hideHeaderOnCurrentRoute()){
      <banner-install-cicerone />
    }

    @if((tools.isApp || tools.isDistributor) && 
        showPassport() && 
        !hideHeaderOnCurrentRoute() &&
        !isCustomRoute()){
      <app-passport-fab />
    }
    
    @if(this.rest.device()?.hasIncidentsSurvey &&
        isOnline() &&
        !hideHeaderOnCurrentRoute() &&
        !isCustomRoute()) {
      <app-incidents-reporter-button />
    }
  }

</ion-app>

@if(tools.isApp || tools.isDistributor){
  <div class="d-none">
    <google-translate />
  </div>
}

@if(tools.showRouteSpinner()){
  <div class="spinner-loader-route">
    <ion-spinner />
  </div>
}
